<nz-layout class="layout">
  <nz-sider
    *ngIf="!shouldHideAppShell()"
    [ngClass]="{
      'collapsed-nz-sider': isCollapsed,
      'expanded-nz-sider': !isCollapsed
    }"
    [nzCollapsible]="true"
    [(nzCollapsed)]="this.isCollapsed"
    [nzTrigger]="null"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    ><gains-sidenav [sidenavCollapsed]="isCollapsed" (sidenavCollapsedChange)="closeNavbarInstantly()"></gains-sidenav
  ></nz-sider>
  <nz-content [ngClass]="{ 'content-container': !shouldHideAppShell() }">
    <div class="flex-container">
      <div class="breadcrumb-block">
        <gains-breadcrumb></gains-breadcrumb>
      </div>

      <div class="content-block">
        <ng-content></ng-content>
      </div>
    </div>
  </nz-content>

  <gains-alerts-tray *ngIf="!shouldHideAppShell()" [sidenavCollapsed]="isCollapsed" (openChanged$)="onAlertsTrayOpenChanged($event)"></gains-alerts-tray>
</nz-layout>
